import { render, staticRenderFns } from "./YoutubeBackground.vue?vue&type=template&id=9dd2f50c&scoped=true&"
import script from "./YoutubeBackground.vue?vue&type=script&lang=js&"
export * from "./YoutubeBackground.vue?vue&type=script&lang=js&"
import style0 from "./YoutubeBackground.vue?vue&type=style&index=0&id=9dd2f50c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dd2f50c",
  null
  
)

export default component.exports